// extracted by mini-css-extract-plugin
export default {"doc-page-wrapper":"p_bg container-lg d-flex p-3","doc-page":"p_bh","doc-page__title--enterprise":"p_bj","doc-page--with-side-menu":"p_bk","doc-page__title":"p_bl"};